export enum DownloadType{
	ZIP = 'ZIP',
	PDF = 'PDF',
}
